import React, { lazy, Suspense, useEffect } from "react";
import CheckoutStepper from "../checkoutStepper/checkoutStepper";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./CheckoutSummary.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FullPageSpinner from "../../layout/FullPageSpinner";
import { toast } from "react-toastify";

// Lazy Load the Cart component
const Cart = lazy(() => import("./Cart"));
const PlacedOrder = lazy(() => import("./PlacedOrder"));

const stepLabel = ["🛒 SHOPPING CART", "📦 ORDER CONFIRMATION"];
const stepPaths = ["cart", "checkout"];

const CheckoutSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const currentPath = location.pathname.replace("/", ""); // Get the current path
  const activeStep = stepPaths.indexOf(currentPath); // Determine active step index

  useEffect(() => {
    const paymentStatus = searchParams.get("payment") || searchParams.get("status") || searchParams.get("payment_status") || searchParams.get("txStatus");
    const errorMessage = searchParams.get("message") || searchParams.get("error");
    
    if (paymentStatus === "failed" || paymentStatus === "failure" || paymentStatus === 'suc') {
      toast.error(errorMessage || "Payment failed! Please try again or use a different payment method.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  }, [searchParams]);

  // Dynamically render the correct component
  const renderStepComponent = () => {
    switch (currentPath) {
      case "cart":
        return (
          <Suspense fallback={<FullPageSpinner loading={true} />}>
            <Cart />
          </Suspense>
        );
      // case "payment":
      //   return <PaymentMethod />;
      case "checkout":
        return (
          <Suspense fallback={<FullPageSpinner loading={true} />}>
            <PlacedOrder />
          </Suspense>
        );
      default:
        return (
          <Suspense fallback={<FullPageSpinner loading={true} />}>
            <Cart />
          </Suspense>
        ); // Default to Cart if path doesn't match
    }
  };

  return (
    <div>
      <div className="container-fluid stepper-header">
        <div className="container py-3">
          <div className="row">
            <div className="col-md-4">
              <div
                className="h-100 d-flex align-items-center text-white"
                style={{ cursor: "pointer", width: "fit-content" }}
                onClick={() => navigate(-1)}
              >
                <ArrowBackIcon className="me-2" />
                <span>Continue Shopping</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stepper Navigation */}
      <div className="container">
        <div className="stepper-label mt-4">{stepLabel[activeStep]}</div>
      </div>

      <CheckoutStepper activeStep={activeStep} />

      {/* Load the appropriate component dynamically */}
      {renderStepComponent()}
    </div>
  );
};

export default CheckoutSummary;
